const OS = require('../../models/environ/os');

/**
 * DeviceFlag
 * @class
 */
class DeviceFlag {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      classes: {
        iosClass: 'is-ios',
      },
    }
  };

  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param _opts {object}
   */
  constructor(_$el, opts = {}) {
    const { classes } = _.defaultsDeep(opts, DeviceFlag.defOpts);

    const { ios } = OS.getInstance();

    if(ios) {
      _$el.classList.add(classes.iosClass)
    }
  }

}

/**
 * class exports
 */
module.exports = DeviceFlag;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/device-flag.js
 **/